import { render, staticRenderFns } from "./tab-2-buypoint.vue?vue&type=template&id=1d1c2b62&scoped=true&lang=pug&"
import script from "./tab-2-buypoint.vue?vue&type=script&lang=js&"
export * from "./tab-2-buypoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c2b62",
  null
  
)

export default component.exports